// src/pages/quality/QualityView.jsx
import { useParams } from "react-router-dom";
import FormViewManager from "../../components/common/form/FormViewManager";

import QualityMIView from "../../components/quality/view/QualityMIView";
import QualityPCView from "../../components/quality/view/QualityPCView";
import QualityNCView from "../../components/quality/view/QualityNCView";
import QualityCAView from "../../components/quality/view/QualityCAView";

// 🔹 form_type에 따라 실제 뷰를 골라주는 라우터 컴포넌트
function QualityViewRouter({ data, meta, project }) {
  const VIEW_MAP = {
    MI: QualityMIView,
    PC: QualityPCView,
    NC: QualityNCView,
    CA: QualityCAView,
  };

  // 🚨 [수정 포인트 1] 타입 감지 로직 강화
  // 로그상 "PC"는 data.meta.doc_type에 들어있었습니다.
  const formType = (
    data?.form_type ||
    data?.doc_type ||
    data?.meta?.doc_type || // ✅ 여기가 핵심!
    ""
  ).toUpperCase();

  console.log("QUALITY formType Detected:", formType);

  const ViewComp =
    VIEW_MAP[formType] ||
    (() => (
      <div className="p-4 text-gray-500">
        지원되지 않는 문서 형식입니다 ({formType || "알 수 없음"})
      </div>
    ));

  // 🚨 [수정 포인트 2] PC(체크리스트)인 경우, View가 바로 header를 쓸 수 있게 meta를 data로 전달
  // QualityPCView 코드는 data.header를 기대하고 있는데, API 원본 data는 { meta: { header: ... } } 구조임
  // 🔥 수정: DNS도 함께 주입 (data.doc_dns or data.dns) + MI DNS 링크
  const viewData =
    formType === "PC" && data?.meta
      ? { ...data.meta, dns: data.doc_dns || data.dns, mi_dns: data.mi_dns }
      : data;

  return <ViewComp data={viewData} meta={meta} project={project} />;
}

export default function QualityView() {
  const { id: projectId, dns } = useParams();

  return (
    <FormViewManager
      params={{
        project: projectId,
        dns,
        module: "quality",
        doc_type: "", // 조회 시에는 보통 빈 값으로 두고 로드된 데이터로 판단
      }}
      doc_name="품질 문서"
    >
      {/* ✅ FormViewManager가 로드한 data를 props로 이 컴포넌트에 주입해줍니다. */}
      <QualityViewRouter />
    </FormViewManager>
  );
}
